import { useMemo } from "react";
import { mapModelsToFiles } from "domains/file-manager/interfaces";
import { mapFileModelsToFmFileModels } from "domains/file-manager/utils/mapFmFileToFile";
import { useUserContext } from "domains/user/contexts/UserProvider";
import { useGetPublicModelsQuery } from "infra/api/generated/api";

import { skipToken } from "@reduxjs/toolkit/dist/query";

import useAllModels from "./useAllModels";

export type UseAllPublicModelsArgs = {
  placeholder?: never;
};

export default function useAllPublicModels(
  props: UseAllPublicModelsArgs | undefined
) {
  const { isUnsigned } = useUserContext();

  const unsignedResult = useGetPublicModelsQuery(
    isUnsigned && props
      ? {
          pageSize: "50",
        }
      : skipToken
  );
  const signedResult = useAllModels(
    !isUnsigned && props
      ? {
          privacyFilter: "public",
          isFeaturedPrioritized: true,
        }
      : undefined
  );

  const unsignedFiles = useMemo(() => {
    return mapFileModelsToFmFileModels(
      mapModelsToFiles(unsignedResult.data?.models ?? [])
    );
  }, [unsignedResult.data?.models]);

  const signedFiles = useMemo(() => {
    return mapFileModelsToFmFileModels(signedResult.files);
  }, [signedResult.files]);

  return {
    files: !isUnsigned ? signedFiles : unsignedFiles,
    loadMore: () => {},
    hasMore: !isUnsigned ? signedResult.hasMore : false,
    isLoading: !isUnsigned ? signedResult.isLoading : unsignedResult.isLoading,
  };
}
